import { FinanceDetails } from "../../store/user";
interface ButtonData {
  title: string;
  icon: string;
  link: string;
}
interface AllowedBalanceItem {
  title: string;
  key: keyof FinanceDetails;
  currencyKey: string;
  hidden?: boolean;
}

export const allowedBalance: AllowedBalanceItem[] = [
  {
    title: "Available balance",
    key: "balance",
    currencyKey: "$",
  },
  {
    title: "Spending balance",
    key: "available",
    currencyKey: "$",
  },
  {
    title: "Total balance",
    key: "balance",
    currencyKey: "currency",
    hidden: true,
  },
];

export const buttonData: ButtonData[] = [
  {
    title: "Add Money",
    icon: "/assets/icons/moneySend.svg",
    link: "",
  },
  {
    title: "Send Money",
    icon: "/assets/icons/moneySend.svg",
    link: "",
  },
  {
    title: "Convert Funds",
    icon: "/assets/icons/repeat.svg",
    link: "",
  },
];
